/** Optional synchronous observers for reversible application brush commands. */
type Observer = { begin(imageId: string): void; beforeVoxel(imageId: string, i: number, j: number, k: number): void; end(imageId: string): void };
const observers = new Set<Observer>();
export function observePaintStrokes(observer: Observer) { observers.add(observer); return () => observers.delete(observer); }
export const paintStrokeEvents = {
  begin: (imageId: string) => observers.forEach(o => o.begin(imageId)),
  beforeVoxel: (imageId: string, i: number, j: number, k: number) => observers.forEach(o => o.beforeVoxel(imageId, i, j, k)),
  end: (imageId: string) => observers.forEach(o => o.end(imageId)),
};
